import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'languagesMulti',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have languages.",
  getURL: 'languages/localesPaginated',
  fields: [
    {
      attributeName: 'language',
      label: 'Language',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      helpText: 'Language name.',
    },
    {
      attributeName: 'locale',
      label: 'Locale',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      helpText: 'Locale code.',
    },
    {
      attributeName: 'country',
      label: 'Country',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      canOpen: false,
      helpText: 'Country name.',
    },
  ],
};